export const LOAD_DATA = 'at/workflowSettings/LOAD_DATA'
export const LOAD_DATA_SUCCESS = 'at/workflowSettings/LOAD_DATA_SUCCESS'
export const LOAD_DATA_FAILURE = 'at/workflowSettings/LOAD_DATA_FAILURE'

export const CREATE_NEW_STATUS = 'at/workflowSettings/CREATE_NEW_STATUS'
export const CREATE_NEW_STATUS_SUCCESS = 'at/workflowSettings/CREATE_NEW_STATUS_SUCCESS'
export const CREATE_NEW_STATUS_FAILURE = 'at/workflowSettings/CREATE_NEW_STATUS_FAILURE'

export const EDIT_STATUS = 'at/workflowSettings/EDIT_STATUS'
export const EDIT_STATUS_SUCCESS = 'at/workflowSettings/EDIT_STATUS_SUCCESS'
export const EDIT_STATUS_FAILURE = 'at/workflowSettings/EDIT_STATUS_FAILURE'

export const DELETE_STATUS = 'at/workflowSettings/DELETE_STATUS'
export const DELETE_STATUS_SUCCESS = 'at/workflowSettings/DELETE_STATUS_SUCCESS'
export const DELETE_STATUS_FAILURE = 'at/workflowSettings/DELETE_STATUS_FAILURE'

export const CHANGE_STATUS_POSITION = 'at/workflowSettings/CHANGE_STATUS_POSITION'
export const CHANGE_STATUS_POSITION_SUCCESS = 'at/workflowSettings/CHANGE_STATUS_POSITION_SUCCESS'
export const CHANGE_STATUS_POSITION_FAILURE = 'at/workflowSettings/CHANGE_STATUS_POSITION_FAILURE'

export const SET_ERRORS = 'at/workflowSettings/SET_ERRORS'
export const START_EDIT_STATUS = 'at/workflowSettings/START_EDIT_STATUS'
export const UPDATE_EDITING_STATUS = 'at/workflowSettings/UPDATE_EDITING_STATUS'
export const START_CREATE_STATUS = 'at/workflowSettings/START_CREATE_STATUS'
export const CANCEL_EDIT_OR_CREATE_STATUS = 'at/workflowSettings/CANCEL_EDIT_OR_CREATE_STATUS'

export const TOGGLE_DIALOG_VISIBILITY = 'at/workflowSettings/TOGGLE_DIALOG_VISIBILITY'



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/actionTypes.js